import axios from 'axios'
import Cookies from 'js-cookie'

const https = require('https')

const agent = new https.Agent({
  rejectUnauthorized: false,
})

const token = Cookies.get('auth-sigep')

export default axios.create({
  baseURL: `${process.env.REACT_APP_API_DNS}`,
  responseType: 'json',
  httpsAgent: agent,
  headers: {
    Authorization: `Bearer ${token}`,
  },
})
